import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import useFormValidator from 'useFormValidator';
import Select from 'react-select';
import { customStyle } from 'helper';
import * as actions from '../action';
import * as c from '../constant';

function BarangayModal({
  createBarangay,
  getBarangayList,
  history,
  getSingleBarangay,
  districtList,
  getDistrictList,
  type,
  updateBarangay,
  updateList,
  barangayId,
}) {
  const [formData, setFormData] = useState({
    name: '',
    code: '',
    rptax_district_id: '',
    zone_number: '',
  });
  const validateForm = useFormValidator(formData, {
    name: 'required',
    code: 'required',
    rptax_district_id: 'required',
    zone_number: 'required',
  });

  useEffect(() => {
    getDistrictList();
  }, []);

  const setModal = useContext(ModalContext);

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();

    if (type === 'NEW') {
      createBarangay(formData, ({ data }) => {
        setModal({ isOpen: false });
        getBarangayList();
        history.push(
          `/rpt/settings/property-locations/barangays/${_.get(data, 'id')}`
        );
        getSingleBarangay(data.id);
      });
    }

    if (type === 'EDIT') {
      updateBarangay(barangayId, formData, ({ data }) => {
        setModal({ isOpen: false });
        getBarangayList();
        history.push(
          `/rpt/settings/property-locations/barangays/${_.get(data, 'id')}`
        );
        getSingleBarangay(data.id);
      });
    }


  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  const onSetFormData = () => {
    if (!_.isEmpty(updateList)) {
      const args = {
        ...updateList,
      };
      setFormData(_.pick(args, _.keys(c.FORM_DATA)));
    }
  };

  useEffect(() => {
    if (type === 'EDIT') {
      onSetFormData();
    }
  }, []);

  const districtOptions = districtList.map(x => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
  }));

  const handleSelected = key => (e) => {
    setFormData({
      ...formData,
      [key]: e.value,
    });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Code {validateForm.renderMessage('code')}
            </label>
            <input
              className="form-control"
              type="number"
              name="code"
              onChange={onChange}
              value={_.get(formData, 'code')}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Name {validateForm.renderMessage('name')}
            </label>
            <input
              className="form-control"
              type="text"
              name="name"
              onChange={onChange}
              value={_.get(formData, 'name')}
            />
          </div>
          <div className="col-12 form-group">
            <label className="form-label">District
              &nbsp; {validateForm.renderMessage('rptax_district_id')}
            </label>
            <div>
              <Select
                options={districtOptions}
                styles={customStyle}
                placeholder="Select District"
                value={districtOptions.filter(item => +_.get(formData, 'rptax_district_id') === +_.get(item, 'id')) || ''}
                onChange={handleSelected('rptax_district_id')}
              />
            </div>
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Zone Number {validateForm.renderMessage('zone_number')}
            </label>
            <input
              className="form-control"
              type="number"
              name="zone_number"
              onChange={onChange}
              value={_.get(formData, 'zone_number')}
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={!validateForm.response.is_passed}
            type="submit"
            className="mt-3 btn btn-primary mr-3"
          >
            <span className="font-weight-bold">
              Submit
            </span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

BarangayModal.defaultProps = {
  type: '',
  updateList: {},
  barangayId: '',
}

BarangayModal.propTypes = {
  type: PropTypes.string,
  barangayId: PropTypes.string,
  updateList: PropTypes.instanceOf(Object),
  getBarangayList: PropTypes.instanceOf(Function).isRequired,
  createBarangay: PropTypes.instanceOf(Function).isRequired,
  updateBarangay: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getSingleBarangay: PropTypes.instanceOf(Function).isRequired,
  getDistrictList: PropTypes.instanceOf(Function).isRequired,
  districtList: PropTypes.instanceOf(Array).isRequired,
};

const mapStateToProps = ({ api }) => ({
  districtList: _.get(api, `${c.GET_DISTRICT_LIST}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(BarangayModal);
